module.exports = "img/flags/MY.48c1a0c.png";